import {HouseApi} from "../api/houseApi"

function findHouseById(state, houseId) {
    return state.houses.find(function (house) {
        return house.id === houseId
    })
}

function findApartmentById(house, apartmentId) {
    return house.apartments.find(function (apartment) {
        return apartment.id === apartmentId;
    })
}

export default {
    state: {
        houses: [],
        nonResidentialFloorArea: -1
    },

    getters: {
        houses: function (state) {
            return state.houses;
        },

        nonResidentialFloorArea: function (state) {
            return state.nonResidentialFloorArea;
        },

        findHouseById: function (state) {
            return function (houseId) {
                return state.houses.find(function (house) {
                    return house.id === houseId;
                })
            }
        },

        findApartmentById: function (state) {
            return function (houseId, apartmentId) {
                const house = findHouseById(state, houseId);
                return findApartmentById(house, apartmentId)
            };
        },

        totalNumberOfApartmentsInHouse: function (state) {
            return function (houseId) {
                return findHouseById(state, houseId).apartments
                    .reduce(function (acc, apartment) {
                        return acc += apartment.count;
                    }, 0);
            }
        }
    },

    actions: {
        async createHouse({commit, rootState, getters}) {
            const refHouseIdx = getters.currentReferenceHouseIndex;
            const refHouse = getters.filteredReferenceHouses[refHouseIdx];

            try {
                commit('addHouse', await HouseApi.createHouse(rootState.projectId, refHouse.id))
            } catch (error) {
                console.log(error)
            }
        },
        async createHouseWithCustomRefHouse({commit, rootState}, customReferenceHouse) {
            try {
                commit('addHouse', await HouseApi.createHouseWithCustomRefHouse(rootState.projectId, customReferenceHouse))
            } catch (error) {
                console.log(error)
            }
        },
        async getHouses({commit, rootState}) {
            try {
                commit('updateHouses', await HouseApi.getHouses(rootState.projectId))
            } catch (error) {
                console.log(error)
            }
        },
        async removeHouse({commit, rootState}, payload) {
            try {
                await HouseApi.removeHouse(rootState.projectId, payload.houseId);
                commit('removeHouse', {houseId: payload.houseId})
            } catch (error) {
                console.log(error)
            }
        },
        async updateHouses({commit, rootState, state}) {
            try {
                commit('showSavingNotification');
                const body = {
                    houses: state.houses,
                    nonResidentialFloorArea: state.nonResidentialFloorArea,
                };

                commit('updateHouses', await HouseApi.updateHouses(rootState.projectId, body));
                commit('hideSavingNotification')
            } catch (error) {
                console.log(error);
                commit('hideSavingNotification')
            }
        },
    },

    mutations: {
        removeHouse: function (state, payload) {
            var idx = state.houses.findIndex(function (house) {
                return house.id === payload.houseId;
            });
            state.houses.splice(idx, 1)
        },
        changeFloor: function (state, payload) {
            var house = findHouseById(state, payload.houseId);
            house.floors += payload.delta
        },
        updateApartment: function (state, payload) {
            var house = findHouseById(state, payload.houseId);
            var apartment = findApartmentById(house, payload.apartmentId);
            apartment.count = payload.count;
            apartment.minCount = payload.minCount;
            apartment.maxCount = payload.maxCount
        },
        changeApartment: function (state, payload) {
            var house = findHouseById(state, payload.houseId);
            findApartmentById(house, payload.apartmentId).count += payload.delta
        },
        updateHouseName: function (state, payload) {
            findHouseById(state, payload.houseId).name = payload.newValue
        },
        updateNonResidentialFloorArea: function (state, payload) {
            state.nonResidentialFloorArea = payload
        },
        updateHouses(state, payload) {
            state.houses = payload
        },
        addHouse(state, payload) {
            state.houses.push(payload)
        }
    }
}



// WEBPACK FOOTER //
// ./assets/vue/houseModel/store/housesState.js